import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Voy a estar incomunicado?',
  answer: 'No, aprenderás a usar la tecnología como herramienta, no como juguete.'
}, {
  question: '¿Es para siempre?',
  answer: 'No, es un reinicio de 7 días. El día 8 vuelves al mundo con un nuevo "cableado" mental.'
}, {
  question: '¿Qué pasa si fallo un día?',
  answer: 'El protocolo incluye una guía de recuperación inmediata para volver al camino sin culpas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark px-4 py-16 md:py-24" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-38">
          <h2 className="font-bebas text-4xl md:text-6xl text-white leading-tight" data-id="element-39">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-4" data-id="element-40">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-dark-lighter border border-teal/20 rounded-lg overflow-hidden" data-id="element-41">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-dark/50 transition-colors" data-id="element-42">
                  <h3 className="font-inter font-semibold text-lg text-white pr-4" data-id="element-43">
                    {faq.question}
                  </h3>
                  <ChevronDownIcon className={`w-5 h-5 text-teal flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-44" />
                </button>

                <AnimatePresence data-id="element-45">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-46">
                      <div className="px-6 pb-6" data-id="element-47">
                        <p className="font-inter text-base text-text/80 leading-relaxed" data-id="element-48">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}